import React from 'react';
import { motion } from 'framer-motion';
import { 
  ShieldCheck, 
  Users, 
  Scale, 
  Briefcase, 
  FileText, 
  Home, 
  ArrowRight 
} from 'lucide-react';

const productList = [
  {
    title: "Fractional General Counsel",
    description: "Expert legal leadership integrated into your executive team on a flexible, as-needed basis.",
    icon: <Users size={28} />,
  },
  {
    title: "DPDP Implementation",
    description: "Comprehensive framework and roadmap for Digital Personal Data Protection Act compliance.",
    icon: <ShieldCheck size={28} />,
  },
  {
    title: "Whistleblower and POSH",
    description: "End-to-end implementation of internal reporting systems and anti-harassment frameworks.",
    icon: <Scale size={28} />,
  },
  {
    title: "Labor Codes Deployment",
    description: "Strategic transition and implementation strategies for the new national labor codes and regulations.",
    icon: <Briefcase size={28} />,
  },
  {
    title: "Regulatory and Secretarial Compliances",
    description: "Ensuring full adherence to statutory requirements, filings, and corporate governance standards.",
    icon: <FileText size={28} />,
  },
  {
    title: "Estate Planning",
    description: "Structuring personal and business assets for seamless succession and future protection.",
    icon: <Home size={28} />,
  }
];

const Products = () => {
  const brandNavy = "#0c3754";
  const brandGreen = "#78BE20";

  return (
    <section className="bg-white py-24 px-8 md:px-16 border-t border-slate-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6">
          <div>
            <div className="flex items-center gap-4 mb-6">
              <div className="h-[1px] w-12 bg-[#0c3754]/20" />
              <span style={{ color: brandNavy }} className="text-[10px] uppercase tracking-widest font-bold">
                Specialized Solutions
              </span>
            </div>
            <h2 style={{ color: brandNavy }} className="text-5xl font-serif leading-tight">
              Our <span className="opacity-40 font-light">Products</span>
            </h2>
          </div>
          <p className="text-slate-500 text-sm max-w-sm leading-relaxed">
            Strategic legal packages designed to provide immediate value and 
            long-term compliance stability for your organization.
          </p>
        </div>

        {/* Changed grid-cols-4 to grid-cols-3 to fit 6 items perfectly (2 rows of 3) */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {productList.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.8 }}
              whileHover={{ y: -10 }}
              className="group relative p-8 rounded-xl border border-slate-100 bg-slate-50/30 hover:bg-white hover:shadow-[0_30px_60px_-15px_rgba(12,55,84,0.1)] transition-all duration-500"
            >
              <div 
                style={{ color: brandNavy }} 
                className="mb-8 p-4 w-fit rounded-lg bg-white shadow-sm group-hover:bg-[#78BE20] group-hover:text-white transition-colors duration-500"
              >
                {item.icon}
              </div>

              <h3 style={{ color: brandNavy }} className="text-xl font-serif mb-4">
                {item.title}
              </h3>

              <p className="text-slate-500 text-xs leading-relaxed mb-8">
                {item.description}
              </p>

              <div 
                style={{ color: brandGreen }}
                className="flex items-center gap-2 text-[10px] font-bold tracking-widest opacity-0 group-hover:opacity-100 transition-all duration-500 translate-y-2 group-hover:translate-y-0 uppercase"
              >
                View Details <ArrowRight size={12} />
              </div>

              <div 
                style={{ backgroundColor: brandGreen }}
                className="absolute top-0 left-0 w-full h-1 rounded-t-xl scale-x-0 group-hover:scale-x-100 transition-transform duration-500" 
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;